(() => {
  // Explicit QA opt-in only. No storage, requests, field values or cart metadata.
  if (new URLSearchParams(window.location.search).get('ccm_checkout_diagnostic') !== '1') return;
  const button = document.getElementById('checkout');
  const form = button?.form;
  if (!button || !form || form.id !== 'cart') return;

  const originalLabel = button.getAttribute('aria-label');
  const labelPrefix = originalLabel || button.textContent.trim();
  const records = [];
  const observations = new Set();
  let active = true;
  let lastLabel = null;
  let cartTimer;
  const snapshot = () => {
    const rect = button.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;
    const inViewport = x >= 0 && y >= 0 && x < window.innerWidth && y < window.innerHeight;
    const hit = inViewport ? document.elementFromPoint?.(x, y) : null;
    let invalid = 0;
    for (const control of form.elements) {
      if (control.willValidate && control.validity?.valid === false) invalid++;
      if (invalid === 99) break;
    }
    return {
      invalid,
      disabled: button.disabled,
      bounds: [rect.x, rect.y, rect.width, rect.height].map(Math.round),
      inViewport,
      centerHit: Boolean(hit && (hit === button || button.contains(hit))),
      scale: Math.round((window.visualViewport?.scale || 1) * 10) / 10,
    };
  };
  const record = (kind, prevented = false) => {
    if (!active) return;
    records.push({ kind, prevented, ...snapshot() });
    if (records.length > 8) records.shift();
    lastLabel = `${labelPrefix}. Checkout QA ${JSON.stringify(records)}`;
    button.setAttribute('aria-label', lastLabel);
  };
  const afterEvent = (event, kind) => {
    // Trusted events can run microtasks between listeners; observe in a later task.
    if (observations.size === 8) {
      const oldest = observations.values().next().value;
      window.clearTimeout(oldest);
      observations.delete(oldest);
    }
    const observation = window.setTimeout(() => {
      observations.delete(observation);
      record(kind, event.defaultPrevented);
    }, 0);
    observations.add(observation);
    if (cartTimer === undefined) {
      cartTimer = window.setTimeout(() => {
        if (button.isConnected && form.isConnected) record('still-cart-12s');
      }, 12000);
    }
  };
  const onClick = (event) => {
    if (event.target === button || button.contains(event.target)) afterEvent(event, 'click');
  };
  const onSubmit = (event) => {
    if (event.target === form && (!event.submitter || event.submitter === button)) afterEvent(event, 'submit');
  };
  const stop = () => {
    active = false;
    window.clearTimeout(cartTimer);
    window.clearTimeout(expiryTimer);
    observations.forEach((timer) => window.clearTimeout(timer));
    observations.clear();
    document.removeEventListener('click', onClick, true);
    document.removeEventListener('submit', onSubmit, true);
    window.removeEventListener('pagehide', stop);
    if (button.getAttribute('aria-label') === lastLabel) {
      if (originalLabel === null) button.removeAttribute('aria-label');
      else button.setAttribute('aria-label', originalLabel);
    }
    records.length = 0;
  };
  const expiryTimer = window.setTimeout(stop, 120000);
  document.addEventListener('click', onClick, { capture: true, passive: true });
  document.addEventListener('submit', onSubmit, { capture: true, passive: true });
  window.addEventListener('pagehide', stop, { once: true });
  record('armed');
})();
